import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class EntryService {
    private entryClickEvent = new BehaviorSubject<{ thesaurusId: string, entry: number } | null>(null);
    private backLinkClickEvent = new BehaviorSubject<void>(undefined);

    emitEntryClick(thesaurusId: string, entry: number) {
        this.entryClickEvent.next({ thesaurusId, entry });
    }
    getEntryClickEvent() {
        return this.entryClickEvent.asObservable();
    }

    getBackLinkClickEvent() {
        return this.backLinkClickEvent.asObservable();
    }
    emitBackLinkClickEvent() {
        this.backLinkClickEvent.next();
    }
}
